import { NeutralButton } from "../../common/Buttons"
import { useState } from "react"
import Spinner from "../../common/Spinner"
import { useNavigate } from "react-router-dom"
import useStore from "../../../store"
import ActionConfirmDrawer from "../../common/ActionConfirmDrawer"

export default function AuditButton({ dealer, unitIds = null, auditType = 2, notTouchedOnly = false, label = null }) {
  const navigate = useNavigate()
  const createFieldAudit = useStore((state) => state.createFieldAudit)

  const [creatingFieldAudit, setCreatingFieldAudit] = useState(false)
  const [isOpen, setIsOpen] = useState(false)

  const buttonText = () => {
    if (creatingFieldAudit) {
      return <Spinner height="25px" />
    } else if (label) {
      return label
    } else if (unitIds && dealer?.attributes['current-field-audit-id']) {
      return 'Go to Dealer Audit'
    } else if (unitIds) {
      return 'Start Unit Audit'
    } else if (dealer?.attributes['current-field-audit-id']) {
      return 'Resume Audit'
    } else {
      return 'Start Audit'
    }
  }

  const unitCount = notTouchedOnly
    ? dealer?.attributes['unseen-unit-count']
    : unitIds ? unitIds.length : dealer?.attributes['audit-unit-count']

  const handleButtonClick = () => {
    if (dealer?.attributes['current-field-audit-id']) {
      navigate(`/field_audits/${dealer?.attributes['current-field-audit-id']}`)
    } else {
      setIsOpen(true)
    }
  }

  const handleConfirm = () => {
    if (creatingFieldAudit) { return }

    if (dealer?.attributes['current-field-audit-id']) {
      navigate(`/field_audits/${dealer?.attributes['current-field-audit-id']}`)
    } else {
      setCreatingFieldAudit(true)
      createFieldAudit({
        dealer_id: dealer?.id,
        unit_ids: unitIds,
        audit_type: auditType,
        ...(notTouchedOnly && { not_touched_only: 'true' })
      }, (fieldAudit) => {
        navigate(`/field_audits/${fieldAudit.id}`)
        setCreatingFieldAudit(false)
      })
    }
  }

  return (
    <>
      <NeutralButton
        text={buttonText()}
        onClick={handleButtonClick}
      />
      <ActionConfirmDrawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
        onCancel={() => setIsOpen(false)}
        onConfirm={handleConfirm}
        isConfirming={creatingFieldAudit}
        placement="bottom"
        title={`Audit ${dealer?.attributes['name'] ?? 'Dealer'}`}
        body={`Start an audit for ${unitCount} ${unitCount === 1 ? 'unit' : 'units'}?`}
      />
    </>
  )
}